/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CatalogDto } from '../models/catalog-dto';
import { ContractDto } from '../models/contract-dto';
import { CustomerDto } from '../models/customer-dto';
import { getCatalog } from '../fn/svgzapi-core/get-catalog';
import { GetCatalog$Params } from '../fn/svgzapi-core/get-catalog';
import { getCustomer } from '../fn/svgzapi-core/get-customer';
import { GetCustomer$Params } from '../fn/svgzapi-core/get-customer';
import { getCustomerContracts } from '../fn/svgzapi-core/get-customer-contracts';
import { GetCustomerContracts$Params } from '../fn/svgzapi-core/get-customer-contracts';
import { upsertCustomerContract } from '../fn/svgzapi-core/upsert-customer-contract';
import { UpsertCustomerContract$Params } from '../fn/svgzapi-core/upsert-customer-contract';

@Injectable({ providedIn: 'root' })
export class SvgzapiCoreService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCustomer()` */
  static readonly GetCustomerPath = '/svgs/{svgId}/customers/{customerId}';

  /**
   * Retrieves a customer.
   *
   * Retrieves a customer from svgzapi-core
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomer()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomer$Response(params: GetCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerDto>> {
    return getCustomer(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a customer.
   *
   * Retrieves a customer from svgzapi-core
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomer(params: GetCustomer$Params, context?: HttpContext): Observable<CustomerDto> {
    return this.getCustomer$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerDto>): CustomerDto => r.body)
    );
  }

  /** Path part for operation `getCatalog()` */
  static readonly GetCatalogPath = '/svgs/{svgId}/customers/{customerId}/catalog';

  /**
   * Product catalog for a given svg.
   *
   * Retrieves product catalog for a given svg from svgzapi-core. That catalog defines, which contracts can be created. A customer can get a contract for a given product in customers svgs catalog.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCatalog()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCatalog$Response(params: GetCatalog$Params, context?: HttpContext): Observable<StrictHttpResponse<CatalogDto>> {
    return getCatalog(this.http, this.rootUrl, params, context);
  }

  /**
   * Product catalog for a given svg.
   *
   * Retrieves product catalog for a given svg from svgzapi-core. That catalog defines, which contracts can be created. A customer can get a contract for a given product in customers svgs catalog.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCatalog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCatalog(params: GetCatalog$Params, context?: HttpContext): Observable<CatalogDto> {
    return this.getCatalog$Response(params, context).pipe(
      map((r: StrictHttpResponse<CatalogDto>): CatalogDto => r.body)
    );
  }

  /** Path part for operation `getCustomerContracts()` */
  static readonly GetCustomerContractsPath = '/svgs/{svgId}/customers/{customerId}/contracts';

  /**
   * Retrieves contracts of a customer.
   *
   * Retrieves contracts of a customer from svgzapi-core
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerContracts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerContracts$Response(params: GetCustomerContracts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContractDto> | null>> {
    return getCustomerContracts(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves contracts of a customer.
   *
   * Retrieves contracts of a customer from svgzapi-core
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomerContracts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerContracts(params: GetCustomerContracts$Params, context?: HttpContext): Observable<Array<ContractDto> | null> {
    return this.getCustomerContracts$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ContractDto> | null>): Array<ContractDto> | null => r.body)
    );
  }

  /** Path part for operation `upsertCustomerContract()` */
  static readonly UpsertCustomerContractPath = '/svgs/{svgId}/customers/{customerId}/contracts/{product}/upsert';

  /**
   * Upsert a contract of a customer.
   *
   * Upsert a contract of a customer from svgzapi-core
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertCustomerContract()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertCustomerContract$Response(params: UpsertCustomerContract$Params, context?: HttpContext): Observable<StrictHttpResponse<ContractDto>> {
    return upsertCustomerContract(this.http, this.rootUrl, params, context);
  }

  /**
   * Upsert a contract of a customer.
   *
   * Upsert a contract of a customer from svgzapi-core
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upsertCustomerContract$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertCustomerContract(params: UpsertCustomerContract$Params, context?: HttpContext): Observable<ContractDto> {
    return this.upsertCustomerContract$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContractDto>): ContractDto => r.body)
    );
  }

}
